import React from "react";

function EventTag({className, tagIcon, eventCountInfo}) {

  return (
    <div className={`${className || ""} course-event-tag d-flex align-items-center justify-content-center gap-1`}>
      {tagIcon && <span>{tagIcon}</span>}
      <span>{eventCountInfo}</span>
    </div>
  );
}

export default EventTag;
